import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { media } from '../../../styles/style-utils';

import Section from '../../common/Section';
import { BLOCK_TYPE, blocksToComponents } from '../utils/Contentful';
import Anchor from '../utils/Anchor';

const Wrapper = styled(Section)`
  padding: var(--default-vertical-padding) 1rem;
  text-align: left;

  ${media.mediumLarge`
    padding: var(--default-vertical-padding) var(--default-horizontal-padding);
    text-align: center;
  `}
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;

  > :not(:last-child) {
    margin-bottom: 3rem;
  }

  ${media.large`
    flex-direction: row;
    align-items: stretch;

    > :not(:last-child) {
      margin-right: 3rem;
      margin-bottom: 0;
    }
  `}
`;

const ThreeColumnsHeroBlock = ({ content }) => {
  const { blocks, blockId } = content;

  return (
    <React.Fragment>
      <Anchor id={blockId} />
      <Wrapper>
        {blocks && (
          <Column>
            {blocks.map(block =>
              blocksToComponents({
                block,
                src: BLOCK_TYPE.THREE_COLUMNS_HERO_BLOCK,
              })
            )}
          </Column>
        )}
      </Wrapper>
    </React.Fragment>
  );
};

ThreeColumnsHeroBlock.propTypes = {
  content: PropTypes.object,
};

export default ThreeColumnsHeroBlock;



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/heroBlock/ThreeColumnsHeroBlock.js